export enum MajorDimension {
	ROWS,
	COLUMNS,
}
